import { useArticles } from "@/hooks/useArticles";
import { ArticleGrid } from "@/components/ArticleGrid";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const InterviewList = () => {
  const { data: articles, isLoading } = useArticles();
  const navigate = useNavigate();

  const filteredArticles = articles?.filter(
    (article) => article.category === "INTERVIEW"
  );

  return (
    <div className="py-24 bg-gradient-to-b from-white via-soft-blue/10 to-white min-h-screen">
      <div className="container px-4">
        <div className="flex items-center mb-8">
          <Button
            variant="ghost"
            onClick={() => navigate("/")}
            className="mr-4"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            戻る
          </Button>
          <div>
            <h1 className="text-3xl md:text-4xl font-light text-elegant tracking-[0.2em]">
              INTERVIEW
            </h1>
            <p className="text-elegant/60 text-sm tracking-[0.2em]">
              インタビュー記事
            </p>
          </div>
        </div>

        <ArticleGrid
          articles={filteredArticles}
          isLoading={isLoading}
          searchQuery=""
          selectedCategory={null}
        />
      </div>
    </div>
  );
};

export default InterviewList;